import { Translation } from '../../ts/interfaces/translation.interface';

const errors: Translation = {
  title: 'Error',
  subTitle: 'Something went wrong',
  unexpectedError: 'Something unexpected happened, please try again.',
};

export default errors;
